export default {
  tabs: {
    profile: 'Profiili',
    branding: 'Brändäys',
    domain: 'Verkkotunnus',
    earning: 'Ansainta',
    feature_flags: 'Ominaisuusliput',
    notification_channels: 'Ilmoituskanavat',
    pricing: 'Hinnoittelu',
    fees: 'Maksut',
    payments: 'Maksutavat',
    billing: 'Laskutus',
  },
  earning: {
    internal_notice: 'Vain FoodAmigosin sisäiset asetukset. Eivät näy kumppanille.',
    read_only_notice: 'Vain luku. Napsauta Muokkaa muuttaaksesi arvoa.',
    editing_notice: 'Muokataan — muutokset vaikuttavat todellisiin maksulaskelmiin.',
  },
  fees: {
    internal_notice:
      'Vain FoodAmigosin sisäiset asetukset. Eivät näy kumppanille, ja vain pääkäyttäjät voivat avata tämän välilehden. Muutokset vaikuttavat siihen, mitä ruokailijoilta veloitetaan ja mitä alusta ansaitsee.',
    read_only_notice: 'Vain luku. Napsauta Muokkaa muuttaaksesi arvoja tällä välilehdellä.',
    editing_notice:
      'Muokataan — Tallenna kirjoittaa sekä palvelumaksun että käsittelymaksut. Hinnat koskevat seuraavasta veloituksesta alkaen; aiemmat tapahtumat säilyttävät niihin kirjatun katteen.',
  },
  profile: {
    read_only_notice: 'Vain luku. Napsauta Muokkaa muuttaaksesi arvoa.',
    editing_notice: 'Muokataan — näyttönimi näkyy kuluttajille.',
    form: {
      name: {
        label: 'Kumppanin nimi',
        hint: 'Virallinen yrityksen nimi. Käytetään sisäisesti ja laskutusasiakirjoissa.',
      },
      display_name: {
        label: 'Kuluttajalle näkyvä nimi',
        hint: 'Asiakkaille näkyvä "Toteuttaja ___" -teksti. Oletuksena kumppanin nimi, jos tyhjä.',
      },
      admin_email: {
        label: 'Ylläpitäjän sähköposti',
        hint: 'Kutsuttu ylläpitäjätili. Ei voi muuttaa täällä — ota yhteyttä kehitystiimiin tilin siirtämiseksi.',
      },
      invoicing_emails: {
        label: 'Laskutussähköpostit',
        hint: 'Tälle kumppanille laskutettujen laskujen kuitit lähetetään jokaiseen näistä osoitteista. Jätä tyhjäksi käyttääksesi ylläpitäjän sähköpostia.',
        placeholder: 'Ylläpitäjän sähköposti',
      },
      status: {
        label: 'Tila',
        hint: 'Kutsutut kumppanit aktivoituvat ensimmäisellä kirjautumisella — manuaalinen aktivointi ohittaa tämän. Keskeyttäminen poistaa käytöstä kaikki kumppanin tiimin kirjautumiset.',
      },
      region: {
        label: 'Alue',
        hint: 'Maa on kiinteä. Valitse osavaltio, jos kumppanin ravintolat noudattavat osavaltiokohtaisia verosääntöjä — tämä muuttaa vain kumppanin oletusarvoja, ei olemassa olevia ravintoloita.',
      },
      messenger_audience: {
        label: 'Tukichatti',
        hint: 'Kuka tämän kumppanin alaisuudessa saa FoodAmigosin tukichatin. FoodAmigos-henkilöstöllä on se aina. Omalla brändillä toimivat kumppanit tukevat itse ravintoloitaan, joten vain heidän ylläpitäjänsä saavat sen.',
        options: {
          everyone: 'Kaikki, ravintolat mukaan lukien',
          partner_admins: 'Vain kumppanin ylläpitäjät',
          nobody: 'Ei kukaan',
        },
      },
      shop_domains: {
        label: 'Kauppadomainit',
        hint: 'Juuridomainit, joilla kumppanin ravintolakaupat toimivat. Ensisijaista domainia käytetään uusille brändeille. Kumppani yhdistää ja irrottaa itse omat kauppadomaininsa; Domain-välilehti näyttää niiden DNS-tietueet.',
      },
    },
    region: {
      whole_country: 'Koko maa',
    },
    shop_domains: {
      primary: 'Ensisijainen',
      platform_default: 'Alustan oletus',
      empty: 'Ei vielä yhdistettyä kauppadomainia',
    },
    statuses: {
      invited: 'Kutsuttu',
      active: 'Aktiivinen',
      suspended: 'Keskeytetty',
    },
    custody: {
      label: 'Maksujen käsittely',
      not_configured: 'Ei vielä määritetty',
      provider: 'Kumppanin oma maksupalvelu',
      platform: 'FoodAmigos käsittelee maksut',
      bank_account: {
        set: 'Pankkitili: {{label}} ({{status}})',
        missing: 'Ei vielä pankkitiliä. Kumppani syöttää sen Kumppanin laskutus -kohdassa.',
        statuses: {
          active: 'aktiivinen',
          pending_verification: 'vahvistetaan',
          action_needed: 'vaatii toimenpiteitä',
          errored: 'maksu epäonnistui',
          missing: 'puuttuu',
        },
      },
      hint: 'Määräytyy Maksut-välilehden maksuasetusten mukaan ja lukittuu, kun maksutapa on tallennettu. FoodAmigosin käsittelyssä kumppanin tulo-osuus maksetaan kuukausittain.',
      kyc: {
        label: 'Maksutilitys',
        missing: 'Ei vielä luotu',
        incomplete: 'Vahvistus kesken',
        complete: 'Valmis maksutilityksiin',
        currently_due: 'Stripe tarvitsee vielä: {{fields}}',
        send_link: 'Lähetä käyttöönottolinkki',
        link_copied:
          'Käyttöönottolinkki kopioitu leikepöydälle — välitä se kumppanille. Se on kertakäyttöinen ja vanhenee.',
        link_ready: 'Käyttöönottolinkki — välitä se kumppanille (kertakäyttöinen, vanhenee)',
        link_failed: 'Käyttöönottolinkkiä ei voitu luoda.',
      },
    },
    suspend_confirm: {
      title: 'Keskeytetäänkö tämä kumppani?',
      description:
        'Kaikki kumppanin tiimin jäsenet poistetaan käytöstä ja heidän istuntonsa perutaan. Heidän ravintolansa pysyvät toiminnassa.',
    },
  },
  branding: {
    read_only_notice: 'Vain luku. Napsauta Muokkaa muuttaaksesi arvoa.',
    editing_notice: 'Muokataan — muutokset näkyvät kumppanin omalla brändillä varustetuilla näkymillä.',
    upload: 'Lataa logo',
    logo: {
      label: 'Logo',
      hint: 'Näkyy kumppanin omalla brändillä varustetuilla näkymillä.',
    },
    circle_logo: {
      label: 'Favicon / pyöreä logo',
      hint: 'Neliömäinen logo, jota käytetään faviconina ja avatarina. Valinnainen — voidaan poistaa.',
    },
    splash_image: {
      label: 'Kirjautumiskuva',
      hint: 'Täyttää kumppanin oman brändin kirjautumissivun vasemman puoliskon reunasta reunaan (rajataan peittäväksi). Suositus: pystysuuntainen kuva, vähintään 1200 × 1200 px. Valinnainen — voidaan poistaa.',
    },
    footer_note: 'Lisää brändäysasetuksia (toissijaiset värit) tulossa myöhemmin.',
  },
  revenue_split: {
    title: 'Tulonjako',
    description:
      'Aseta kumppanin osuus kustakin maksusta, jonka FoodAmigos kerää sen ravintoloiden tilauksista. Oletus 0 % — FoodAmigos pitää koko maksun, kunnes osuus myönnetään. Maksetaan jokaisella laskutusjaksolla.',
    manage_on_fees: 'Hallinnoi Maksut-välilehdellä',
    split: 'Kumppani {{partner}} % · FoodAmigos {{platform}} %',
    rows: {
      processing: 'Käsittelymaksut',
      gift_card: 'Lahjakortin maksu',
      delivery: 'Toimitusmaksut',
      service_fee: 'Palvelumaksu',
    },
    notes: {
      service_fee: 'Ruokailijoilta veloitettava summa asetetaan Palvelumaksun hallinta -kohdassa Maksut-välilehdellä.',
    },
  },
  service_fee_controls: {
    title: 'Palvelumaksun hallinta',
    description: 'Mitä kumppani veloittaa ruokailijoiltaan palvelumaksuna tilauksen lisäksi.',
    zero_percentage_warning:
      '0 %:n prosenttiosuus ei poista palvelumaksua käytöstä: vähimmäismäärän alittavat lasketut maksut pyöristetään ylöspäin siihen, joten jokaiselta tilaukselta veloitetaan silti vähintään vähimmäismäärä.',
  },
  hard_limits: {
    title: 'Ehdottomat rajat',
    description:
      'FoodAmigosin kattoarvot, jotka pakotetaan tallennettaessa ja kassalla. Mikään tämän kumppanin palvelumaksu — mukaan lukien ravintolakohtaiset poikkeukset — ei saa ylittää näitä.',
    max_percentage: {
      label: 'Enimmäispalvelumaksu %',
      help: 'Kumppanin palvelumaksua ei voi asettaa tätä korkeammaksi. Alustan raja: 5 %.',
    },
    min_amount: {
      label: 'Vähimmäispalvelumaksun summa',
      help: 'Ravintolakohtaisia vähimmäismääriä ei voi asettaa tätä pienemmäksi.',
    },
    max_amount: {
      label: 'Enimmäispalvelumaksun summa',
      help: 'Kiinteän palvelumaksun ehdoton yläraja prosentista riippumatta.',
    },
  },
  form: {
    is_service_fee_change_allowed: {
      label: 'Salli palvelumaksun muuttaminen ravintolakohtaisesti',
      description: 'Sallii kumppanin yksittäisten ravintoloiden käyttää eri palvelumaksua.',
    },
    service_fee_platform_share: {
      label: 'Foodamigosin osuus palvelumaksusta',
    },
    recommended: 'Suositus: {{value}}',
    service_fee_percentage: {
      label: 'Oletuspalvelumaksuprosentti',
      help: 'Koskee kaikkia kumppanin ravintoloita, ellei toisin ohiteta.',
    },
    min_service_fee_amount: {
      label: 'Oletusvähimmäismaksun summa',
      help: 'Vähimmäismäärä tilausta kohden — sen alittavat lasketut maksut pyöristetään ylöspäin. Ravintolat voivat asettaa omansa FoodAmigosin rajoissa.',
    },
    max_service_fee_amount: {
      label: 'Oletusenimmäismaksun summa',
      help: 'Yläraja tilausta kohden — ravintolat voivat asettaa omansa FoodAmigosin rajoissa.',
    },
    primary_color: {
      label: 'Ensisijainen brändiväri',
    },
    dashboard_subdomain: {
      label: 'Kumppanin kirjautumistunniste (slug)',
      hint: 'Pienillä kirjaimilla oleva tunniste — yksilöi kumppanin brändin sen tiimin kirjautumislinkissä (?partner=…).',
      placeholder: 'kumppanin-nimi',
    },
    login_url: {
      label: 'Tiimin kirjautumislinkki',
      hint: 'Linkki, jolla kumppanin tiimi pääsee sen brändätylle kirjautumissivulle.',
    },
    file: {
      label: 'Kuva',
    },
  },
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
  },
  toasts: {
    load_error: 'Asetuksia ei voitu ladata.',
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
    logo_uploaded: 'Logo ladattu',
    logo_upload_failed: 'Logon lataaminen epäonnistui',
    logo_removed: 'Logo poistettu',
    logo_remove_failed: 'Logon poistaminen epäonnistui',
    file_too_large: 'Tiedosto on liian suuri. Enimmäiskoko on {{max}} Mt.',
    image_too_narrow: 'Kirjautumiskuvan on oltava vähintään {{min}} px leveä.',
  },
  notification_channels: {
    master_locked:
      'Pääkumppani lähettää jokaisen alustan ravintolan puolesta, joten sen kanavia ei voi muuttaa täällä.',
    unavailable: 'Ilmoituskanavat eivät ole vielä käytettävissä tällä taustajärjestelmällä.',
    notice:
      'Sisäinen asetus. Kumppanin, jolla ei ole omaa Twilio-tiliä, on pysyttävä vain sähköpostissa: muuten jokainen tekstiviesti, WhatsApp-viesti ja puhelu lähtisi FoodAmigosin Twilio-tililtä.',
    forbidden: 'Vain pääkäyttäjät voivat muuttaa ilmoituskanavia.',
    columns: {
      channel: 'Kanava',
      status: 'Käytössä',
    },
    channels: {
      email: {
        name: 'Sähköposti',
        description: 'Aina käytössä, jotta kumppaniin ja sen ravintoloihin saa aina yhteyden.',
      },
      sms: {
        name: 'Tekstiviesti',
        description: 'Tilauspäivitykset ja kirjautumiskoodit vieraille tekstiviestillä.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Hälytykset ravintoloitsijoille ja kirjautumiskoodit vieraille WhatsAppissa.',
      },
      voice_call: {
        name: 'Puhelut',
        description: 'Muistutuspuhelut avoimista tilauksista ja puheluihin vastaaminen.',
      },
      push: {
        name: 'Push-ilmoitukset',
        description:
          'Push-ilmoitukset vieraille ja omistajan hallintapaneelisovellukseen. Henkilökunnan tablettihälytyksiin tämä ei vaikuta.',
      },
    },
    toasts: {
      load_error: 'Ilmoituskanavia ei voitu ladata.',
      error: 'Ilmoituskanavia ei voitu tallentaa.',
      saved: 'Ilmoituskanavat tallennettu.',
    },
  },
  feature_flags: {
    internal_notice: 'Vain FoodAmigosin omat asetukset. Eivät näy kumppanille. Muutokset tulevat voimaan heti.',
    read_only:
      'Vain luku – ravintolan laskutuksen muuttaminen vaatii koordinoidun käyttöönoton, ei pelkkää kytkintä. Ota yhteyttä kehitystiimiin.',
    forbidden: 'Vain pääkäyttäjät voivat hallita kumppanin ominaisuuslippuja.',
    columns: {
      feature: 'Ominaisuus',
      status: 'Tila',
    },
    flags: {
      external_printer: {
        name: 'Ulkoinen kuittitulostin',
        description:
          'Oletusasetus ravintoloille, jotka tämä kumppani ottaa käyttöön tästä eteenpäin: jokainen uusi ravintola voi alusta alkaen yhdistää verkkokuittitulostimen tilauspäätesovellukseen. Olemassa olevat ravintolat säilyttävät oman Ominaisuusliput-välilehtensä asetuksen, ja jokaista ravintolaa voi edelleen muuttaa yksitellen siellä.',
      },
      plg_onboarding: {
        name: 'Itsepalvelu (PLG) -käyttöönotto',
        description:
          'Itsepalvelukumppanien käyttöönotto: antaa tälle kumppanille ohjatun Uusi ravintola -sivun ja käyttöönottovelhon perinteisen Lisää yritys -ikkunan ja Aloita-vaiheiden sijaan, piilottaa vain FoodAmigosille tarkoitetut ja vielä soveltumattomat näkymät kumppanilta ja sen ravintoloilta, ja estää ensimmäisen julkaisun, kunnes julkaisupäivästä on sovittu. Käytössä kaikilla uusilla kumppaneilla.',
      },
      issue_end_customer_receipts: {
        name: 'Loppuasiakkaan laskut',
        description:
          'Antaa vieraille mahdollisuuden pyytää lasku kassalla ja saada se sähköpostitse. Pois päältä uusilla kumppaneilla; kansainväliset laskumuotosäännöt tekevät tuesta kallista.',
      },
      merchant_billing: {
        name: 'Ravintolan laskutus',
        description:
          'Laskuttaa kumppanin ravintoloita alustan kautta. Pois päältä tarkoittaa, että ne maksavat sen ulkopuolella.',
      },
      cuisine_backfill: {
        name: 'Keittiötyypin jälkitäyttö',
        description: 'Sallii automaattisen keittiötyypin jälkitäytön ajamisen tämän kumppanin ravintoloille.',
      },
      image_backfill: {
        name: 'Kuvien jälkitäyttö',
        description: 'Sallii automaattisen ruokalistakuvien jälkitäytön ajamisen tämän kumppanin ravintoloille.',
      },
      auto_image_generation: {
        name: 'Automaattinen kuvien luonti',
        description: 'Luo ruokalistakuvia tarvittaessa tämän kumppanin ravintoloille.',
      },
      provider_billing: {
        name: 'Foodamigosin suorittama kumppanin laskutus',
        description:
          'Sisällyttää tämän kumppanin Foodamigosin laskutusajoon. Pois päältä tarkoittaa, että kumppania laskutetaan alustan ulkopuolella. Ottaa myös käyttöön PayPalin (suora) tämän kumppanin ravintoloille, ja palvelumaksu veloitetaan sen kautta.',
      },
      partner_custom_dashboard_domain: {
        name: 'Oma hallintapaneelin verkkotunnus',
        description:
          'Antaa tälle kumppanille mahdollisuuden yhdistää oman verkkotunnuksen hallintapaneeliin, jolloin sen tiimi ja ravintolat kirjautuvat sisään kumppanin omalla osoitteella. Päälle tai pois kytkeminen muuttaa jokaista hallintapaneelilinkkiä, jonka alusta lähettää tälle kumppanille.',
      },
      partner_custom_shop_domain: {
        name: 'Oma verkkokaupan verkkotunnus',
        description:
          'Antaa tälle kumppanille mahdollisuuden yhdistää oman verkkotunnuksen ravintoloidensa verkkokauppoihin, jonka alla jokainen ravintola saa oman osoitteensa. Avaa kerrallaan vain yhdelle kumppanille: se muuttaa osoitetta, jota asiakkaat käyttävät.',
      },
      partner_legal_documents: {
        name: 'Kumppanin lakisääteiset asiakirjat',
        description:
          'Luo tämän kumppanin ravintoloiden verkkokaupoille yhteystiedot, tietosuojakäytännön ja käyttöehdot kunkin ravintolan omien lakisääteisten tietojen perusteella. Pois päältä, tai kun ravintolan tiedot ovat puutteelliset, kaupoissa näkyvät alustan vakioasiakirjat.',
      },
    },
    toasts: {
      load_error: 'Ominaisuuslippujen lataaminen epäonnistui',
      error: 'Ominaisuuslipun muuttaminen epäonnistui',
      enabled: 'Ominaisuus käytössä',
      disabled: 'Ominaisuus pois käytöstä',
    },
  },
};
